import React, { useState, useEffect } from 'react'
import {
    Box,
    Container,
    makeStyles,
    Modal,
    CircularProgress
} from '@material-ui/core'
import Page from '../../../components/Page'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import moment from 'moment'
import firebase from 'firebase/app'
import Toolbar from './Toolbar'
import PostCard from '../../../components/PostCard'
import '../../../theme/calendar.css'

const localizer = momentLocalizer(moment) // or globalizeLocalizer
const timeOffset = moment(new Date()).utcOffset()

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    postCard: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        maxHeight: '80%',
        maxWidth: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        overflowY: 'auto',
        boxShadow: theme.shadows[5]
    }
}))

const ProductList = () => {
    const classes = useStyles()
    const [posts, setPosts] = useState()
    const [pages, setPages] = useState()
    const [postModalOpen, setPostModalOpen] = useState(false)
    const [selectedPost, setSelectedPost] = useState()

    function handleClose() {
        setPostModalOpen(false)
    }

    useEffect(() => {
        firebase
            .firestore()
            .collection('pages')
            .orderBy('createDate', 'desc')
            .get()
            .then((docs) => {
                const _pages = []
                if (!docs.empty) {
                    docs.forEach((page) => {
                        const _page = page.data()

                        _pages.push({ ..._page, id: page.id })
                    })
                }

                setPages(_pages)
            })
    }, [])

    async function getPosts() {
        return (
            firebase
                .firestore()
                .collection('posts')
                .orderBy('createDate', 'desc')
                .where('createDate', '>=', new Date())
                .where('byAdmin', '==', true)
                // .limit(20)
                .onSnapshot((docs) => {
                    const _posts = []
                    if (!docs.empty) {
                        docs.forEach((post) => {
                            const _post = post.data()
                            let title = ''

                            if (_post.picture) {
                                title = '\u{1F4F7}'
                            }

                            if (_post.text?.length > 0) {
                                title += _post.text
                            }

                            _posts.push({
                                ..._post,
                                id: post.id,
                                title,
                                startDateTime: moment(_post.createDate.toDate())
                                    .add(-timeOffset / 60, 'h')
                                    .toDate(),
                                endDateTime: moment(_post.createDate.toDate())
                                    .add(-timeOffset / 60, 'h')
                                    .add(10, 'minutes')
                                    .toDate()
                            })
                        })
                    }

                    setPosts(_posts)
                })
        )
    }

    useEffect(() => getPosts(), [])

    return (
        <Page className={classes.root} title="Publisher">
            <Container maxWidth={false}>
                <Toolbar pages={pages} />

                <Box mt={3}>
                    {posts ? (
                        <Calendar
                            localizer={localizer}
                            events={posts}
                            onSelectEvent={(post) => {
                                setSelectedPost(post)
                                setPostModalOpen(true)
                            }}
                            getNow={() => {
                                return moment(new Date())
                                    .add(-timeOffset / 60, 'h')
                                    .toDate()
                            }}
                            startAccessor="startDateTime"
                            endAccessor="endDateTime"
                            style={{
                                height: window.innerHeight - 294,
                                minHeight: 500
                            }}
                        />
                    ) : (
                        <CircularProgress />
                    )}
                </Box>
            </Container>

            <Modal
                // disableBackdropClick={!!loading}
                open={postModalOpen}
                onClose={handleClose}
                aria-labelledby="selected-post-modal"
                aria-describedby="selected-post-modal-description"
            >
                <>
                    {selectedPost ? (
                        <PostCard
                            className={classes.postCard}
                            post={selectedPost}
                        />
                    ) : (
                        <CircularProgress />
                    )}
                </>
            </Modal>
        </Page>
    )
}

export default ProductList
